var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m21.157.73a2.763 2.763 0 0 1 2.76 2.76v11.02a2.763 2.763 0 0 1 -2.76 2.76h-17.667a2.763 2.763 0 0 1 -2.76-2.76v-11.02a2.763 2.763 0 0 1 2.76-2.76zm0-.73h-17.667a3.5 3.5 0 0 0 -3.49 3.49v11.02a3.5 3.5 0 0 0 3.49 3.49h17.667a3.5 3.5 0 0 0 3.49-3.49v-11.02a3.5 3.5 0 0 0 -3.49-3.49","fill":"#54d2df","key":0}),React.createElement("path",{"d":"m23.489 2.3-10.789 8.621a.555.555 0 0 1 -.689 0l-10.787-8.621m0 13.286 8.66-6.627m13.476 6.624-8.66-6.627","fill":"none","stroke":"#77d0dd","key":1})]);
}

Email.defaultProps = {"height":"18","viewBox":"0 0 24.647 18","width":"24.647"};

module.exports = Email;

Email.default = Email;
